import Carousel from 'react-bootstrap/Carousel';
import image1 from '../assets/slider/new1.jpg';
import image2 from '../assets/slider/new2.jpg';
import image3 from '../assets/slider/new3.jpg';
import image4 from '../assets/slider/new4.jpg';
import image5 from '../assets/slider/new5.jpg';
import image6 from '../assets/slider/new6.jpg';
import image7 from '../assets/slider/new7.jpg';
import image8 from '../assets/slider/new8.jpg';
import image9 from '../assets/slider/new9.jpg';
function HomeCarousel() {
  return (
    <div class="homeCarousel">
    <Carousel fade>
      <Carousel.Item interval={1500}>
      <img src={image1} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv1'>
          <span className="carouselText col or1"><b></b><br></br></span>
          <span className='carouselTextInner color2'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={1500}>
      <img src={image2} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv2'>
          <span className="carouselText color2"><b></b><br></br></span>
          <span className='carouselTextInner color1'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item> 
       <Carousel.Item interval={1500}>
      <img src={image3} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv3'>
          <span className="carouselText color2"><b></b><br></br></span>
          <span className='carouselTextInner color1'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item> 
      <Carousel.Item interval={1500}>
      <img src={image4} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv3'>
          <span className="carouselText color1"><b></b><br></br></span>
          <span className='carouselTextInner color2'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item> 
      <Carousel.Item interval={1500}>
      <img src={image5} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv4'>
          <span className="carouselText color1"><b></b><br></br></span>
          <span className='carouselTextInner color2'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item> 
      <Carousel.Item interval={1500}>
      <img src={image6} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv4'>
          <span className="carouselText color1"><b></b><br></br></span>
          <span className='carouselTextInner color2'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={1500}>
      <img src={image7} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv2'>
          <span className="carouselText color1"><b></b><br></br></span>
          <span className='carouselTextInner color2'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={1500}>
      <img src={image8} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv2'>
          <span className="carouselText color1"><b></b><br></br></span>
          <span className='carouselTextInner color2'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={1500}>
      <img src={image9} class="d-block w-100" alt="..." />
      <Carousel.Caption>
        <div className='carouselDiv2'>
          <span className="carouselText color1"><b></b><br></br></span>
          <span className='carouselTextInner color2'></span>
        </div>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
    </div>
  );
}

export default HomeCarousel;